import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Electrical: React.FC = () => {
  // Define the categories and their items for the electrical catalog
  const electricalCatalog = [
    {
      category: "Conduit Fittings",
      count: "300+",
      items: ["EMT Connectors", "Rigid Connectors", "Flex Connectors", "Couplings", "Straps", "Clamps"]
    },
    {
      category: "Wires",
      count: "200+",
      items: ["THHN", "Romex", "UF", "Low Voltage", "MC Cable", "SER Cable"]
    },
    {
      category: "Breakers",
      count: "100+",
      items: ["Single Pole", "Double Pole", "GFCI", "AFCI", "Tandem", "Main Breakers"]
    },
    {
      category: "Breaker Boxes",
      count: "50+",
      items: ["Main Panels", "Sub Panels", "Load Centers", "Meter Combos", "Transfer Switches"]
    },
    {
      category: "Junction Boxes",
      count: "75+",
      items: ["Indoor Boxes", "Outdoor Boxes", "4S Boxes", "Ceiling Boxes", "Floor Boxes"]
    },
    {
      category: "Wiring Accessories",
      count: "150+",
      items: ["Wire Nuts", "Cable Staples", "Wire Markers", "Electrical Tape", "Cable Ties"]
    },
    {
      category: "Covers & Devices",
      count: "125+",
      items: ["Receptacles", "Switches", "Cover Plates", "GFCI Outlets", "Dimmers"]
    }
  ];

  // Set the page title using useEffect instead of react-helmet
  useEffect(() => {
    document.title = "Electrical Materials Catalog | AccuPrice";
    
    // You can also add meta description this way if needed
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Browse our comprehensive catalog of electrical materials with accurate pricing for contractors and electricians.');
    }
    
    return () => {
      // Reset title when component unmounts (optional)
      document.title = "AccuPrice";
    };
  }, []);

  return (
    <div className="electrical-catalog-page">
      <div className="catalog-hero">
        <h1>Electrical Materials Catalog</h1>
        <p>Our comprehensive electrical price list contains over 1,000 materials for all your residential and light commercial needs.</p>
        <p>All products have been selected and reviewed by expert electricians with decades of experience.</p>
        <Link to="/register" className="catalog-cta-button">Get Access Now</Link>
      </div>

      <div className="catalog-container">
        <h2>What's Included in Our Electrical Price List</h2>
        
        <div className="catalog-table-container">
          <table className="catalog-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Count</th>
                <th>Sample Items</th>
              </tr>
            </thead>
            <tbody>
              {electricalCatalog.map((category, index) => (
                <tr key={index}>
                  <td className="category-name">{category.category}</td>
                  <td className="item-count">{category.count}</td>
                  <td className="sample-items">
                    {category.items.map((item, i) => (
                      <span key={i} className="item-tag">{item}</span>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="catalog-benefits">
          <h2>Benefits of Our Electrical Price List</h2>
          <ul>
            <li>
              <i className="fas fa-check-circle"></i>
              <div>
                <h3>Accurate Pricing</h3>
                <p>Updated monthly to reflect current market prices</p>
              </div>
            </li>
            <li>
              <i className="fas fa-file-export"></i>
              <div>
                <h3>Easy Integration</h3>
                <p>Import directly into QuickBooks and other estimating software</p>
              </div>
            </li>
            <li>
              <i className="fas fa-percentage"></i>
              <div>
                <h3>Customizable Markup</h3>
                <p>Set your own profit margins for different price ranges</p>
              </div>
            </li>
            <li>
              <i className="fas fa-sync"></i>
              <div>
                <h3>Regular Updates</h3>
                <p>New editions released monthly with the latest pricing</p>
              </div>
            </li>
            <li>
              <i className="fas fa-clock"></i>
              <div>
                <h3>Save Time</h3>
                <p>Eliminate hours spent researching and updating prices manually</p>
              </div>
            </li>
            <li>
              <i className="fas fa-shield-alt"></i>
              <div>
                <h3>Protect Your Profits</h3>
                <p>Never underbid a job due to outdated material costs</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="mobile-catalog-summary">
          <h3>Complete Electrical Materials Coverage</h3>
          <p>Our catalog includes everything you need for residential and light commercial electrical work:</p>
          <ul>
            {electricalCatalog.map((category, index) => (
              <li key={index}>
                <strong>{category.category}</strong>: {category.count} items
              </li>
            ))}
          </ul>
        </div>

        <div className="catalog-cta">
          <h2>Ready to Streamline Your Estimating Process?</h2>
          <p>Get access to our complete electrical price list and start creating accurate estimates today.</p>
          <div className="cta-buttons">
            <Link to="/register" className="primary-button">Subscribe Now</Link>
            <a href="https://calendly.com/contact-accupricelists/question-or-help-with-accuprice" target="_blank" rel="noopener noreferrer" className="secondary-button highlight-button">Book a Setup Call & Get 40% Off</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Electrical;